import { DefaultRootState } from 'react-redux';

import { ResumeEditorNotifications } from 'src/models/applicant/resume/editor/store/notifications/types';

export const selectNotifications = ({ resumeEditor }: DefaultRootState): ResumeEditorNotifications =>
    resumeEditor.notifications;
